import React, { useEffect } from 'react'
import { Container, Row,Spinner } from 'react-bootstrap' 
// import data from '../../../data/index'
import Item from './item/Item'
import { Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
  getAllItems,
  selectItems
} from '../../../slice/itemSlice.js'
import categories from '../../../data/categories'

const Items = () => {
  const items = useSelector(selectItems);
  const dispatch = useDispatch();
  
  useEffect(() => {
    dispatch(getAllItems())
  }, [])

  return (
    <Container style={{marginTop:"140px"}}>
      <Row className=''>
        {!categories && <Spinner animation="border" variant="info" />}
        {categories.map(d => <Item key={d.name} name={d.name} image={d.image} />)}
      </Row>
      <div className='items-bottom d-flex flex-row-reverse mt-5'>
        <div className='bg-danger p-5 m-5 text-light border border-2 border-light'>
          <h3 className='display-6 fw-bold'>Latest Accessories</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam a ultricies metus.</p>
          <Link className='py-3 text-light fs-4 h-t-black' to="">See more</Link>
        </div>
      </div>
    </Container>
  )
}

export default Items